import ApiService from "@/utils/request";

export const policyDetailServe = {
  guidelines(id) {
    return ApiService.query(`/policy/v2/inner/guidelines/${id}/`);
  },
  collect(id) {
    return ApiService.post(`/policy/v2/inner/collection/`, {
      guide: id,
    });
  },
  cancelCollect(id) {
    return ApiService.delete(`/policy/v2/inner/collection/${id}`);
  },
};
